<template>
  <transition name="fade">
    <div v-if="isVisible" class="cookie-consent">
      <div class="cookie-consent__inner">
        <p class="cookie-consent__text">
          Мы используем файлы cookie и сервис «Яндекс.Метрика» для сбора обезличенных данных, чтобы сделать сайт удобнее. 
          Продолжая работу с сайтом, вы соглашаетесь с нашей 
          <router-link to="/privacy-policy" target="_blank" class="cookie-consent__link">Политикой конфиденциальности</router-link>.
        </p>
        <AppButton theme="dark" class="cookie-consent__btn" @click="accept">
          Согласен
        </AppButton>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import AppButton from '@/components/ui/AppButton/Index.vue'

export default defineComponent({
  name: 'CookieConsent',
  components: { AppButton },
  setup() {
    const isVisible = ref(false)

    onMounted(() => {
      const consent = localStorage.getItem('cookieConsent')
      if (!consent) {
        isVisible.value = true
      }
    })

    const accept = () => {
      localStorage.setItem('cookieConsent', 'true')
      isVisible.value = false
    }

    return { isVisible, accept }
  }
})
</script>

<style lang="scss" scoped>
.cookie-consent {
  position: fixed;
  bottom: 24px;
  left: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  justify-content: center;

  @media #{$smDown} {
    bottom: 16px;
    left: 16px;
    right: 16px;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
    max-width: 1200px;
    padding: 24px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: 1px solid #e1d7d7;

    @media #{$mdDown} {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin: 0;

    @media #{$smDown} {
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__link {
    color: #4684f7;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  &__btn {
    flex-shrink: 0;
    height: 48px;
    padding: 0 32px;
    font-size: 16px;
    font-weight: 600;

    @media #{$mdDown} {
      width: 100%;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>